import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  margin-top: 8px;
  align-items: center;

`

const Input = styled.input`
  border: 1px solid #ddd;
  padding: 2px 5px;
  outline: none;
  flex-grow: 1;
  color: var(--color-table-filter);

  ::-webkit-calendar-picker-indicator {
    display: none;
  }
`

function DateColumnFilter(props) {
    const {column: {filterValue, setFilter}} = props;


    return (
        <Wrapper>
            <Input
                id={"creation-date-input"}
                type={'date'}
                value={filterValue || ''}
                onChange={e => {
                    setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
                }}
            />
        </Wrapper>
    )
}

export default DateColumnFilter
